import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal
} from '@angular/core';

import { DevAuthUiService } from '@app/core/init/dev-auth-ui.service';

import { SpinLoaderComponent } from '@core/ui/components/spin-loader';

/**
 * Splash de primeira navegação (guards + lazy routes): logo, loader e, em `?mode=dev`,
 * cartão de contexto — layout centrado entre header e rodapé.
 */
@Component({
  selector: 'mw-app-splash',
  standalone: true,
  imports: [SpinLoaderComponent],
  templateUrl: './app-splash.component.html',
  styleUrl: './app-splash.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSplashComponent {
  protected readonly devAuthUi = inject(DevAuthUiService);
  protected readonly year = signal(new Date().getFullYear());
}
